const envObject = {
  // serviceUrl : 'http://localhost:3003/api/v1',
  //serviceUrl : 'http://213.199.57.102:4003/api/v1',
    serviceUrl : 'http://api.muhsems.ac.in/api/v1',
    secretkey  :  ""
};

export const environment = {
production: false,
serviceUrl: envObject.serviceUrl,
key: envObject.secretkey
};